import styled, { css } from "styled-components";
import { color, highContrastStyle, snap, typeStyle, units, visuallyHidden } from "@m/alchemy-theme";
import { MOBILE_BREAKPOINT } from "../constants";
import { NakedButton } from "../../naked-button/NakedButton";
import { AppMenuListItemExpandableItemTrigger } from "../app-menu-list/AppMenuListExpandableItem.styled";
import { AppMenuListItem } from "../app-menu-list/AppMenuList.styled";
export const AppMenuButtonNakedButton = styled(NakedButton) `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${({ labelPlacement }) => (labelPlacement === "start" ? "row-reverse" : "row")};
  padding: 0 ${units(0.25)};
  color: ${color("typeHeader")};
  ${typeStyle("bodyL")};
  text-decoration: none;

  /* This button can be an anchor too so can't use :disabled */
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
`;
export const AppMenuButtonOverlay = styled.div `
  max-width: 300px;
  overflow-y: auto;
  border-radius: 14px;
  background-color: ${color("container")};
  color: ${color("typeBody")};
  box-shadow:
    0 2px 4px 0 rgba(0, 0, 0, 0.08),
    0 6px 18px 0 rgba(0, 0, 0, 0.18);
  min-width: ${snap(208)};

  ${AppMenuListItem} a {
    opacity: 1;
    color: ${color("typeBody")};
    width: 100%;
  }

  ${AppMenuListItem} a[aria-current="page"] {
    background-color: ${color("hint", { palette: "interactiveConstructive" })};
  }
`;
export const AppMenuButtonIconWrapper = styled.span `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: transparent;
  padding: ${({ iconPadding }) => (iconPadding ? `${iconPadding}px` : units(0.5))};
  transition: all ease-in 0.1s;

  transition-property: all;
  animation-timing-function: cubic-bezier(0, 0, 1, 1);
  animation-duration: 0.1s;

  @media (min-width: ${MOBILE_BREAKPOINT}px) {
    padding: ${({ iconPadding }) => (iconPadding ? `${iconPadding}px` : units(1))};
  }

  svg {
    opacity: ${highContrastStyle("1", "0.77")};
    color: ${color("typeHeader")};
  }
`;
export const AppMenuButtonBadge = styled.span `
  ${typeStyle("captionS")}
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  right: 0;
  border-radius: 50%;
  border: 1px solid ${color("contrast")};
  background-color: ${color("base", { palette: "interactiveDestructive" })};
  padding: 0px 5px;
`;
export const AppMenuButtonMobileDialog = styled.div `
  background-color: ${color("inverse")};
  width: 100%;
  padding: ${({ hasHeaderContent }) => (hasHeaderContent ? 0 : `${units(4)} 0 0 0`)};

  ${AppMenuListItem} a {
    opacity: 1;
    color: ${color("typeBody")};
    width: 100%;
  }

  ${AppMenuListItem} a[aria-current="page"] {
    background-color: ${color("hint", { palette: "interactiveConstructive" })};
  }

  /* The default X in dialog doesn't line up to default arrow location, need to adjust in this menu */
  ${AppMenuListItemExpandableItemTrigger} {
    right: 26px;
  }
`;
export const AppMenuButtonLabel = styled.span `
  ${({ shouldHideLabel }) => shouldHideLabel &&
    css `
      ${visuallyHidden()};
    `};
`;
